/**
 * @file   src\validations\authSchema.ts
 * @brief  This file is responsible for defining authentication validation schemas.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import * as Yup from 'yup';
import { EMAIL_REGEX, MIN_PASSWORD_LENGTH } from '../utils/constants';
import { CommonMessages } from '../messages/validationMessages';

// SignIn form validation schema.
export const SIGNIN_SCHEMA = Yup.object({
  email: Yup
    .string()
    .trim()
    .matches(EMAIL_REGEX, CommonMessages.email_invalid)
    .required(CommonMessages.email_required),
  password: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.password_required),
});
// Send otp form validation schema.
export const SEND_OTP_SCHEMA = Yup.object({
  email: Yup
    .string()
    .trim()
    .matches(EMAIL_REGEX, "validation text here")
    .max(200, "validation text here")
    .required("validation text here"),
});
